<template>
  <div class="samsung-cashback-aktion">
    <Breadcrumb
      :items="breadcrumb"
      class="samsung-cashback-aktion__breadcrumb"
    />
    <GridContainer>
      <GridColumn>
        <GridRow class="samsung-cashback-aktion__headline-container">
          <h1 class="samsung-cashback-aktion__headline text--center">Zubehör</h1>
        </GridRow>
      </GridColumn>
    </GridContainer>

    <div class="samsung-cashback-aktion__results-count text--center">{{ offersCount }} Artikel</div>

    <GridContainer class="samsung-cashback-aktion__results">
      <OfferTileList
        v-if="offers?.entries?.length > 0"
        :offers="offers.entries"
      >
        <template #default="{ offer }">
          <OfferTileContainer
            v-if="offer.product"
            :offer="offer"
            has-cart-button
          />
        </template>
      </OfferTileList>
    </GridContainer>
  </div>
</template>

<script>
import { ref } from 'vue';
import Breadcrumb from '@/components/breadcrumb.vue';
import {
  GridRow,
  GridColumn,
  GridContainer,
  OfferTileList,
} from '@i22-td-smarthome/component-library';
import OfferTileContainer from '@/components/offer-tile-container.vue';
import fetchOffers from '@/lib/goliath/offers';
import calculateLastModified from '~/lib/last-modified-offer';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';

const DISPLAYED_OFFER_TYPES = ['TANGIBLE', 'MIXED'];

export default {
  name: 'SamsungCashbackAktion',
  components: {
    Breadcrumb,
    OfferTileContainer,
    GridRow,
    GridColumn,
    GridContainer,
    OfferTileList,
  },
  setup() {
    Track({ page_type: 'theme.landing' });

    getHeader({
      title: ref('Samsung Zubehör'),
      isIndexed: ref(false),
      description: ref(
        'Entdecke unsere Produkte aus der Kategorie Zubehör. Große Auswahl ✓ Schnelle Lieferzeiten ✓ Jetzt bestellen!'
      ),
    });
  },
  async asyncData(context) {
    let offers;
    try {
      offers = await fetchOffers({
        grouped: true,
        filter: {
          listed: true,
          types: DISPLAYED_OFFER_TYPES,
          productAvailable: true,
          articleNumbers: [
            '8806095661797',
            '8806095660547',
            '8806095687933',
            '99935615',
            '99935617',
          ],
        },
        includeAggregations: false,
      });
      // When we are fetching the results from the server-side we are returning
      // a 404 status code when the result set is empty. So we are fully SEO
      // compliant.
      if (process.server && (!offers || offers.pagination.totalCount === 0)) {
        context.res.statusCode = 404;
      }
    } catch (e) {
      const status = (process.server && e.response && e.response.status) || 500;
      context.error({ statusCode: status, message: e.message });
    }
    if (process.server && offers) {
      context.res.setHeader(
        'last-modified',
        calculateLastModified(offers, new Date(context.$config.buildDate))
      );
    }

    return { offers };
  },
  data() {
    return {
      offers: null,
      breadcrumb: [
        {
          label: 'Zubehör',
          to: '/zubehoer',
        },
      ],
    };
  },
  computed: {
    offersCount() {
      return this.offers.variantsCount;
    },
    pagination() {
      return this.offers.pagination;
    },
    hasOffers() {
      return this.pagination.totalCount > 0;
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.samsung-cashback-aktion {
  &__headline {
    margin: {
      top: $grid-medium-gutter;
      bottom: $grid-small-gutter;
    }
    &-container {
      justify-content: center;
    }
  }

  &__results-count {
    font-size: 1.75rem;
    margin-bottom: $grid-medium-gutter;
  }

  &__results {
    margin-bottom: 120px;
  }

  .text {
    &--nowrap {
      white-space: nowrap;
    }
  }
}
</style>
